<template>
  <Body class="page-status" />

  <section class="container section-status">
    <div class="headline flex-center flex-column">
      <h2>{{ $t('참여현황') }}</h2>
      <h1>{{ $t('평화를부르는사람들') }}</h1>
      <p
        v-html="
          $t('어머니사랑을품은한사람의작은실천은세상을변화시키는시작이자br인류가평화로나아가는첫걸음입니다지금함')
        "
      />
    </div>

    <!-- Today -->
    <div class="item-wrap">
      <div class="txt">
        <div class="tit">
          {{ $t('오늘참여현황') }}
        </div>
        <div class="today">
          {{ formatIntlDate(new Date(), locale) }}
        </div>
      </div>
      <div class="participation">
        <div class="item">
          <div class="tit">
            {{ $t('국가') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.today.countryCount ?? 0, locale) }}
          </div>
        </div>
        <div class="item">
          <div class="tit">
            {{ $t('참여인원') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.today.userCount ?? 0, locale) }}
          </div>
        </div>
        <div class="item">
          <div class="tit">
            {{ $t('횟수') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.today.engagementCount ?? 0, locale) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Total -->
    <div class="item-wrap">
      <div class="txt">
        <div class="tit">
          {{ $t('전체참여현황') }}
        </div>
        <div class="base">
          ({{ $t('연인원기준') }})
        </div>
      </div>
      <div class="participation">
        <div class="item">
          <div class="tit">
            {{ $t('국가') }}
          </div>
          <div class="count">
            134
          </div>
        </div>
        <div class="item">
          <div class="tit">
            {{ $t('참여인원') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.total.userCount ?? 0, locale) }}
          </div>
        </div>
        <div class="item">
          <div class="tit">
            {{ $t('횟수') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.total.engagementCount ?? 0, locale) }}
          </div>
        </div>
      </div>
    </div>

    <!-- By activity -->
    <div class="item-wrap">
      <ul class="check-counts">
        <!-- 01 greeting -->
        <li class="list-item">
          <div class="item greeting">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('인사') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[1] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 02 thanks -->
        <li class="list-item">
          <div class="item thanks">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('감사') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[2] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 03 apology -->
        <li class="list-item">
          <div class="item apology">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('사과') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[3] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 04 tolerance -->
        <li class="list-item">
          <div class="item tolerance">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('포용') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[4] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 05 yield -->
        <li class="list-item">
          <div class="item yield">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('양보') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[5] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 06 esteem -->
        <li class="list-item">
          <div class="item esteem">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('존중') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[6] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 07 cheerup -->
        <li class="list-item">
          <div class="item cheerup">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('응원') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[7] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 08 consideration -->
        <li class="list-item">
          <div class="item consideration">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('배려') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[8] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
        <!-- 09 compliment -->
        <li class="list-item">
          <div class="item compliment">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('칭찬') }}
              </div>
              <div class="count">
                {{ formatNumber(data?.item[9] ?? 0, locale) }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>

  <section class="container section-banner">
    <div class="headline flex-center flex-column">
      <p v-html="$t('오늘하루어머니사랑의언어로평화를이뤄보세요')" />
      <h3 v-html="$t('b캠페인b참여하기')" />
      <a href="/checklist" class="btn-color">{{ $t('바로가기') }}</a>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { HmlStatusScreenDataModel } from '~/types/models/models'

const { $t } = useNuxtApp()
useHead({
  title: `${$t('참여현황')} - ${$t('어머니사랑과평화의날캠페인')}`,

  link: [{ rel: 'stylesheet', href: `/css/status.css?${useBuildTime()}` }],
})

const { locale } = useI18n()

const { data } = await useAPI<HmlStatusScreenDataModel>('/hml/v1/screens/status', {
  method: 'GET',
})
</script>
